angular.module('dpw.services')
    .provider('api', function () {
            var defaultErrorMsg = RCDPW.Lang.INTERNAL_ERROR;
            this.setDefaultErrorMsg = function (msg) {
                defaultErrorMsg = msg;
            };
            this.$get = ['$q', '$http', 'helpers', 'dpwStorage', 'mixpanelService', 'Upload',
                function ($q, $http, helpers, dpwStorage, mixpanelService, Upload) {
                    var historyCommonApis = {
                        app: function (params, paging) {
                            params = params || {};
                            return doRequest({
                                url: '/api/history/application',
                                params: params,
                                paging: paging
                            });
                        },
                        org: function (params, paging) {
                            params = params || {};
                            return doRequest({
                                url: '/api/history/organization',
                                params: params,
                                paging: paging
                            });
                        },
                        key: function (params, paging) {
                            params = params || {};
                            return doRequest({
                                url: '/api/history/application-key',
                                params: params,
                                paging: paging
                            });
                        }
                    };
                    var appStates = {
                        list: function (options, paging) {
                            options = options || {};
                            return doRequest({
                                url: '/api/app-states',
                                params: options,
                                paging: paging
                            });
                        },
                        get: function (options) {
                            options = options || {};
                            var id = options.id;
                            return doRequest({
                                url: '/api/app-states/' + id
                            });
                        }
                    };
                    var updateStatus = function (options) {
                        options = options || {};
                        return doRequest({
                            url: '/api/applications/' + options.applicationId + '/update-status',
                            data: options.data,
                            method: 'put'
                        });
                    };

                    var listProfileOriginsAndRevisionsWithAppId = function (options) {
                        options = options || {};
                        return doRequest({
                            url: '/api/app-profile-view/application/' + options.appId
                        });
                    };

                    var rolePermission = {
                        get: function (options) {
                            options = options || {};
                            var developerId = options.id || '~';
                            return doRequest({
                                url: '/api/developers/' + developerId + '/role-permission'
                            });
                        },
                        update: function (options) {
                            options = options || {};
                            var developerId = options.id;
                            return doRequest({
                                url: '/api/developers/' + developerId + '/role-permission',
                                method: 'put',
                                data: options
                            });
                        }
                    };

                    return {
                        call: function (httpPromise, onSuccess, onError) {
                            var self = this;
                            var deferred = $q.defer();
                            var brandId = dpwStorage.getItem('brandId');

                            if (!RCDPW.isAdminSite && brandId && angular.isFunction(helpers.getBrandedMessage)) {
                                defaultErrorMsg = helpers.getBrandedMessage(brandId, 'INTERNAL_ERROR');
                            }

                            // TODO: Extract this function into a shared service - Vi
                            // So that we can define it for both Desktop and Mobile and Testing.
                            function defaultErrorHandler() {
                                RCDPW.modal && RCDPW.modal.create().content(defaultErrorMsg).show();
                            }

                            httpPromise.success(function (data) {
                                if (data == null || angular.isUndefined(data.status)) {
                                    deferred.reject({
                                        data: data,
                                        defaultErrorHandler: defaultErrorHandler
                                    });
                                    defaultErrorHandler();
                                    return;
                                }
                                if (helpers.resUtil.isSuccess(data)) {
                                    angular.isFunction(onSuccess) && onSuccess(data);
                                    deferred.resolve(data);
                                } else {
                                    if (helpers.resUtil.isNotLogin(data) || helpers.resUtil.isNotLoginHasAutoLogin(data)) {
                                        $.removeCookie('IS_LOGIN', {path: '/'});
                                        deferred.reject({
                                            data: data,
                                            defaultErrorHandler: defaultErrorHandler
                                        });
                                        RCDPW.isLogingOut = true;
                                        mixpanelService.reset();

                                        var urlsNeedToBack = ['/administration.html'];
                                        if (RCDPW.isAdminSite && urlsNeedToBack.indexOf(location.pathname) > -1) {
                                            dpwStorage.setItem('previousUrl', location.href, true);
                                        }
                                        if (RCDPW.autoLoginInProgress === true) {
                                            return;
                                        }
                                        if (helpers.resUtil.isNotLoginHasAutoLogin(data)) {
                                            RCDPW.autoLoginInProgress = true;
                                            window.location.pathname = "/api/auto-login";
                                        } else {
                                            window.location.href = '/login';
                                        }
                                        return;
                                    }
                                    if (helpers.resUtil.isTokenInvalid(data)) {
                                        deferred.reject({
                                            data: data,
                                            defaultErrorHandler: defaultErrorHandler
                                        });
                                        RCDPW.isLogingOut = true;
                                        RCDPW.modal && RCDPW.modal.create()
                                            .content(RCDPW.Lang.TOKEN_INVALID)
                                            .ok(function (modal) {
                                                modal.close();
                                                self.call(self.logout(), function () {
                                                    mixpanelService.reset();
                                                    window.location.href = '/login';
                                                });
                                            })
                                            .show();
                                        return;
                                    }
                                    if (helpers.resUtil.isAdminNoPermission(data)) {
                                        deferred.reject({
                                            data: data,
                                            defaultErrorHandler: defaultErrorHandler
                                        });
                                        RCDPW.modal && RCDPW.modal.create().content(RCDPW.Lang.Administration.NO_PERMISSION).show();
                                        return;
                                    }
                                    if (helpers.resUtil.isDeveloperNoPermission(data)) {
                                        RCDPW.modal && RCDPW.modal.create().content([
                                            RCDPW.Lang.MyAccount.RolePermission.SORRY_NO_PERMISSION,
                                            RCDPW.Lang.MyAccount.RolePermission.CONTACT_ADMIN_TO_GRANT_ACCESS
                                        ].join(' ')).show();
                                        return;
                                    }

                                    if (angular.isFunction(onError)) {
                                        onError(data, defaultErrorHandler);
                                    } else {
                                        // no on error callback specified
                                        defaultErrorHandler();
                                    }
                                    deferred.reject({
                                        data: data,
                                        defaultErrorHandler: defaultErrorHandler
                                    });
                                }
                            }).error(function () {
                                deferred.reject({defaultErrorHandler: defaultErrorHandler});
                                defaultErrorHandler();
                            });

                            return deferred.promise;
                        },

                        login: function (options) {
                            options = options || {};
                            return doRequest({
                                url: '/api/login',
                                data: options,
                                asForm: true
                            });
                        },
                        loginAsAdmin: function (options) {
                            options = options || {};
                            return doRequest({
                                url: '/api/login-as-admin',
                                params: options
                            });
                        },

                        logout: function () {
                            $.removeCookie('IS_LOGIN', {path: '/'});
                            return doRequest({
                                url: '/api/logout'
                            });
                        },
                        threeLogout: function (callback) {
                            logoutCLW().then(function () {
                                callback && callback();
                            });

                            function logoutCLW() {
                                return $q(function (resolve) {
                                    var clwDomain = RCDPW.clwDomain || 'login-dpwdevxmn.int.rclabenv.com';
                                    var logoutUrl = 'https://' + clwDomain + '/api/logout';
                                    try {
                                        $.ajax({
                                            url: logoutUrl,
                                            dataType: 'script',
                                            cache: false,
                                            timeout: 5000
                                        }).always(function () {
                                            resolve();
                                        });
                                    } catch (e) {
                                        resolve();
                                    }
                                });
                            }
                        },
                        sso: {
                            getSsoUrl: function (params) {
                                return doRequest({
                                    url: '/api/sso-login-url',
                                    params: params
                                });
                            }
                        },
                        threeLeg: {
                            getLoginUrl: function (params) {
                                return doRequest({
                                    url: '/api/three-leg-login-url',
                                    params: params
                                });
                            }
                        },
                        developerProvision: function () {
                            return doRequest({
                                url: '/api/developer-provision',
                                method: 'post'
                            });
                        },
                        getNumber: function () {
                            return doRequest({
                                url: '/api/get-number'
                            });
                        },
                        getUserInfo: function () {
                            return doRequest({
                                url: '/api/get-user'
                            });
                        },

                        /**
                         * @deprecated
                         */
                        getPublicPosts: function (options) {
                            options = options || {};
                            options.category = 'developer-platform';

                            return getBlogPosts(options);
                        },

                        /**
                         * @deprecated
                         */
                        getAnnouncements: function (options) {
                            options = options || {};
                            options.category = 'developer-announcements';

                            return getBlogPosts(options);
                        },

                        /**
                         * @deprecated
                         */
                        getFaqs: function (options) {
                            options = options || {};
                            options.perPage = options.perPage || 5;
                            options.page = options.page || 1;
                            return doRequest({
                                url: '/api/faqs',
                                params: options
                            });
                        },

                        /**
                         * @deprecated
                         */
                        getImportantNews: function (fetchAll) {
                            return doRequest({
                                url: '/api/important-news',
                                noLoading: true,
                                antiCache: false,
                                params: {
                                    all: fetchAll
                                }

                            });
                        },

                        getTutorials: function (url, fallbackUrl) {
                            var commonOptions = {
                                antiCache: false,
                                params: {
                                    r: moment().format('YYYY-MM-DD')
                                }
                            };
                            var options = _.assign({
                                url: url,
                                timeout: 3000
                            }, commonOptions);
                            var needFallback = fallbackUrl && url !== fallbackUrl;

                            if (!needFallback) {
                                return doRequest(options).then(function (res) {
                                    return res.data;
                                });
                            }

                            var fallbackOptions = _.assign({
                                url: fallbackUrl
                            }, commonOptions);

                            return doRequestWithFallback(options, fallbackOptions);
                        },

                        subscribe: function (options) {
                            options = options || {};
                            return doRequest({
                                url: '/api/marketo/subscribe',
                                data: options,
                                asForm: true
                            });
                        },
                        signup: {
                            signup: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/sign-up',
                                    data: options,
                                    asForm: true
                                });
                            },
                            getCurrentUser: function () {
                                return doRequest({
                                    url: '/api/get-signup-user'
                                });
                            },
                            // TODO: Add Request Invitation API Here - Vi
                            requestInvitation: function () {
                            },
                            requestInvitationIsv: function () {
                            },
                            questionnaire: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/request-questionnaire-invitation',
                                    data: options
                                });
                            }
                        },
                        getDefaultGrantTypes: function (options) {
                            options = options || {};
                            return doRequest({
                                url: '/api/default-grant-types',
                                params: options
                            });
                        },
                        getSecret: function (options) {
                            options = options || {};
                            return doRequest({
                                url: '/api/app-keys/' + options.id + '/secret',
                                noLoading: options.noLoading
                            });
                        },
                        admin: {
                            login: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/login',
                                    data: options,
                                    asForm: true
                                });
                            },
                            getAccountInfo: function (accountId) {
                                return doRequest({
                                    url: '/api/account-info/' + accountId,
                                });
                            },
                            grantTypes: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/grant-types',
                                    params: options
                                });
                            },
                            getBrands: function () {
                                return doRequest({
                                    url: '/api/all-brands-view',
                                });
                            },
                            permissions: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/permissions',
                                    params: options
                                });
                            },
                            requestedPermissions: {
                                get: function (appId) {
                                    return doRequest({
                                        url: '/api/applications/' + appId + '/permission-request',
                                    });
                                },
                                delete: function (appId) {
                                    return doRequest({
                                        url: '/api/applications/' + appId + '/permission-request',
                                        method: 'delete'
                                    });
                                }
                            },
                            requests: {
                                list: function (options, paging, noLoading) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/approval-requests',
                                        params: options,
                                        paging: paging,
                                        noLoading: noLoading
                                    });
                                },
                                detail: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/approval-request-detail/' + options.accountId,
                                        noLoading: true
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    var id = options.requestId;
                                    return doRequest({
                                        url: '/api/approval-requests/' + id
                                    });
                                },
                                approve: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/approval-requests/actions/approve',
                                        data: options,
                                        method: 'put'
                                    });
                                },
                                decline: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/approval-requests/actions/decline',
                                        data: options,
                                        method: 'put'
                                    });
                                }
                            },
                            autoGraduation: {
                                get: function () {
                                    return doRequest({
                                        url: '/api/approval-requests/auto-graduation-flag',
                                        noLoading: true
                                    });
                                },
                                toggle: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/approval-requests/auto-graduation-flag',
                                        data: options.data,
                                        method: 'put'
                                    });
                                }
                            },
                            keys: {
                                get: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys/' + options.id
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys/' + options.id,
                                        data: options.data,
                                        method: 'put',
                                        asForm: true
                                    });
                                },
                                add: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys/',
                                        data: options
                                    });
                                }
                            },
                            applications: {
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    var id = options.applicationId;
                                    return doRequest({
                                        url: '/api/applications/' + id
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.applicationId,
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                uploadIcon: function (appId, file) {
                                    return Upload.upload({
                                        url: '/api/application/' + appId + '/icon',
                                        data: {
                                            icon: file
                                        }
                                    });
                                },
                                updateStatus: updateStatus,
                                getAttributes: function () {
                                    return doRequest({
                                        url: '/api/application/attributes',
                                        method: 'get'
                                    });
                                },
                                updateAttributes: function (options) {
                                    options = options || {};

                                    return doRequest({
                                        url: '/api/application/' + options.applicationId + '/attributes',
                                        data: options.data,
                                        method: 'post'
                                    });
                                },
                                deleteAttribute: function (options) {
                                    options = options || {};

                                    return doRequest({
                                        url: '/api/application/' + options.applicationId + '/attribute/' + options.attributeId,
                                        method: 'delete'
                                    });
                                },
                                hasPublishProfile: function (appId) {
                                    return doRequest({
                                        url: '/api/application/' + appId + '/has-publish-profile',
                                        method: 'get'
                                    });
                                },
                                hasProfileRevision: function (appId) {
                                    return doRequest({
                                        url: '/api/application/' + appId + '/has-revision',
                                        method: 'get'
                                    });
                                }
                            },
                            developers: {
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/developers',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    var id = options.id;
                                    return doRequest({
                                        url: '/api/developers/' + id
                                    });
                                },
                                rolePermission: rolePermission,
                                search: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/technical-contact',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                application: {
                                    getCreator: function (options) {
                                        options = options || {};
                                        var applicationId = options.id;
                                        return doRequest({
                                            url: '/api/developers/application/' + applicationId + '/creator'
                                        });
                                    },
                                    getLatestProdApplicant: function (options) {
                                        options = options || {};
                                        var applicationId = options.id;
                                        return doRequest({
                                            url: '/api/developers/application/' + applicationId + '/latest-prod-applicant'
                                        });
                                    }
                                }
                            },
                            organizations: {
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/organizations',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    var id = options.id;
                                    return doRequest({
                                        url: '/api/organizations/' + id
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    var id = options.id;
                                    return doRequest({
                                        url: '/api/organizations/' + id,
                                        data: options.data,
                                        method: 'put',
                                        asForm: true
                                    });
                                },
                                getPartnerType: function (options) {
                                    options = options || {};
                                    var id = options.id;
                                    return doRequest({
                                        url: '/api/organizations/' + id + '/partner-badge'
                                    });
                                },
                                updatePartnerType: function (options) {
                                    options = options || {};
                                    var id = options.id;
                                    return doRequest({
                                        url: '/api/organizations/' + id + '/partner-badge',
                                        data: {
                                            partnerBadgeType: options.partnerBadgeType
                                        },
                                        method: 'put'
                                    });
                                },
                                updateStatus: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/organizations/' + options.id + '/update-status',
                                        data: options.data,
                                        method: 'put'
                                    });
                                }
                            },
                            history: historyCommonApis,
                            appStates: appStates,
                            usagePlan: {
                                getAll: function () {
                                    return doRequest({
                                        url: '/api/usage-plan-groups'
                                    });
                                },
                                add: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/usage-plans',
                                        data: options,
                                        method: 'post'
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/usage-plans/' + options.id,
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                close: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/usage-plans/' + options.id + '/close',
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                reopen: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/usage-plans/' + options.id + '/reopen',
                                        data: options.data,
                                        method: 'put'
                                    });
                                }
                            },
                            appGallery: {
                                get: function (options) {
                                    options = options || {};
                                    var id = options.id;
                                    return doRequest({
                                        url: '/api/app-gallery/' + id
                                    });
                                },
                                listOriginRevision: function (options, paging) {
                                    options = _.cloneDeep(options) || {};
                                    if (_.get(options, 'status') === 'Approved') {
                                        options.revisionOnly = true;
                                    }
                                    return doRequest({
                                        url: '/api/app-profile-view',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-gallery',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                listOriginsAndRevisionsWithOrgId: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-view/organization/' + options.orgId
                                    });
                                },
                                listOriginsAndRevisionsWithAppId: listProfileOriginsAndRevisionsWithAppId,
                                verifyImages: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-gallery/verify-images',
                                        data: options,
                                        asForm: true
                                    });
                                },
                                approve: function (options) {
                                    options = options || {};
                                    var type = _.get(options, "requests[0].type");
                                    if (type === 'revision') {
                                        return doRequest({
                                            url: '/api/app-profile-revision/' + options.requests[0].id + '/approve',
                                            method: 'put',
                                            data: options
                                        });
                                    }
                                    return doRequest({
                                        url: '/api/app-gallery/actions/approve',
                                        method: 'put',
                                        data: options
                                    });
                                },
                                merge: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-revision/' + options.requests[0].id + '/merge',
                                        method: 'put',
                                        data: options
                                    });
                                },
                                decline: function (options) {
                                    options = options || {};
                                    if (options.requests[0].type === 'revision') {
                                        return doRequest({
                                            url: '/api/app-profile-revision/' + options.requests[0].id + '/merge-deny',
                                            method: 'put',
                                            data: options
                                        });
                                    }
                                    return doRequest({
                                        url: '/api/app-gallery/actions/decline',
                                        method: 'put',
                                        data: options
                                    });
                                },
                                delete: function (profileId) {
                                    return doRequest({
                                        url: '/api/app-profile/' + profileId,
                                        method: 'delete',
                                    });
                                },
                                queryCount: function () {
                                    return doRequest({
                                        url: '/api/app-gallery/count'
                                    });
                                },
                                updatePriority: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'update-priority'].join('/'),
                                        method: 'put',
                                        asForm: true,
                                        data: options
                                    });
                                },
                                updateReleaseDate: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    var type = options.type;
                                    var url = ['/api',
                                        'revision' === type ? 'app-profile-revision' : 'app-gallery',
                                        appProfileId,
                                        'update-release-date']
                                        .join('/');
                                    return doRequest({
                                        url: url,
                                        method: 'put',
                                        asForm: true,
                                        data: options
                                    });
                                },
                                updateH1Tag: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'tag'].join('/'),
                                        method: 'put',
                                        data: options
                                    });
                                },
                                getH1Tag: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'tag'].join('/'),
                                        method: 'get'
                                    });
                                },
                                updateVanityUrl: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'update-vanity-url'].join('/'),
                                        method: 'put',
                                        asForm: true,
                                        data: options
                                    });
                                },
                                updateFeatured: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'update-featured'].join('/'),
                                        method: 'put',
                                        asForm: true,
                                        data: options
                                    });
                                },
                                updateLeadFormFlag: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'lead-flag'].join('/'),
                                        method: 'put',
                                        data: options
                                    });
                                },
                                updateLeadRecipients: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'lead-recipient'].join('/'),
                                        method: 'put',
                                        data: options
                                    });
                                },
                                getLeadSettings: function (options) {
                                    options = options || {};
                                    var appProfileId = options.appProfileId;
                                    return doRequest({
                                        url: ['/api/app-gallery', appProfileId, 'lead-setting'].join('/'),
                                        method: 'get'
                                    });
                                },
                                getLatestRequestBy: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-gallery/' + options.appProfileId + '/latest-request-by'
                                    });
                                },
                                displayStatus: {
                                    get: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: ['/api/app-gallery', options.appProfileId, 'listing-status'].join('/'),
                                            method: 'get'
                                        });
                                    },
                                    hide: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: ['/api/app-gallery', options.appProfileId, 'unlist'].join('/'),
                                            method: 'put'
                                        });
                                    },
                                    show: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: ['/api/app-gallery', options.appProfileId, 'resume-listing'].join('/'),
                                            method: 'put'
                                        });
                                    }
                                },
                                requireLoginGate: {
                                    get: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: ['/api/app-gallery', options.appProfileId, 'list-login-gate-status'].join('/'),
                                            method: 'get'
                                        });
                                    },
                                    disable: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: ['/api/app-gallery', options.appProfileId, 'disable-login-gate'].join('/'),
                                            method: 'put'
                                        });
                                    },
                                    enable: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: ['/api/app-gallery', options.appProfileId, 'enable-login-gate'].join('/'),
                                            method: 'put'
                                        });
                                    }
                                },
                                galleryBrand: function () {
                                    return doRequest({
                                        url: '/api/gallery-brand'
                                    });
                                }
                            },
                            profileTemplate: {
                                get: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-template/application/' + options.appId
                                    });
                                },
                                pendingList: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-template/pending/list',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                declinedList: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-template/decline/list',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                count: function () {
                                    return doRequest({
                                        url: '/api/app-profile-template/count'
                                    });
                                },
                                approve: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-template/application/' + options.appId + '/actions/approve',
                                        method: 'put',
                                        data: options
                                    });
                                },
                                decline: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-template/application/' + options.appId + '/actions/decline',
                                        method: 'put',
                                        data: options
                                    });
                                },
                                getLatestRequestBy: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-profile-template/application/' + options.appId + '/latest-request-by'
                                    });
                                }
                            },
                            ratingsAndReview: {
                                count: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/application/rating-review/count',
                                        params: options,
                                    });
                                }
                            },
                            accountUpgrade: {
                                verify: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/free-account-upgrade/verify',
                                        method: 'post',
                                        data: options.data
                                    });
                                },
                                upgrade: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/free-account-upgrade/upgrade',
                                        method: 'post',
                                        data: options.data
                                    });
                                }
                            },
                            activeAppsWithoutPublished: {
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/public-active-apps-without-profile',
                                        params: options,
                                        paging: paging
                                    });
                                }
                            },
                            adminUsers: {
                                list: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/admin-users',
                                        method: 'post',
                                        data: options
                                    });
                                }
                            }
                        },
                        usagePlan: {
                            list: function (options, paging) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/usage-plans',
                                    params: options,
                                    paging: paging
                                });
                            },
                            listActive: function () {
                                return doRequest({
                                    url: '/api/usage-plans',
                                    params: {
                                        status: 'Active'
                                    }
                                });
                            },
                            get: function (options) {
                                options = options || {};
                                var id = options.id;
                                return doRequest({
                                    url: '/api/usage-plans/' + id
                                });
                            }
                        },
                        myAccount: {
                            glip: {
                                getRecentChats: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/glip/recent/chats',
                                        noLoading: options.noLoading
                                    });
                                },
                                installMna: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/glip/application/' + options.appId + '/groups/' + options.groupId + '/integrations',
                                        method: 'post',
                                        noLoading: options.noLoading
                                    });
                                },
                                uninstallMna: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/glip/application/' + options.appId + '/integrations/' + options.integrationId,
                                        method: 'delete',
                                        noLoading: options.noLoading
                                    });
                                }
                            },
                            getSystemExtension: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/system-extension',
                                    noLoading: options.noLoading
                                });
                            },
                            appStates: appStates,
                            applications: {
                                /**
                                 * @param {String} options.applicationId
                                 * @param {Boolean} options.simple - Fetch application info only.
                                 * @param {Boolean} [options.noLoading]
                                 * @returns {promise}
                                 */
                                checkNameAvailability: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/check-app-name',
                                        data: options.data,
                                        method: 'post'
                                    });
                                },
                                detail: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/application-detail/',
                                        params: options,
                                        noLoading: options.noLoading
                                    });
                                },
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                add: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications',
                                        data: options.data,
                                        method: 'post'
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    var id = options.applicationId;
                                    return doRequest({
                                        url: '/api/applications/' + id
                                    });
                                },
                                getSampleApp: function () {
                                    return doRequest({
                                        url: '/api/quick-start-app'
                                    });
                                },
                                getSampleAppSecret: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/quick-start-app/secret',
                                        method: 'post',
                                        noLoading: options.noLoading
                                    });
                                },
                                clone: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.applicationId + '/clone',
                                        data: options.data,
                                        method: 'post'
                                    });
                                },
                                applyProd: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.applicationId + '/apply-for-production',
                                        data: options.data
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.applicationId,
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                verifyRedirectUris: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/verify-redirect-uris',
                                        data: options
                                    });
                                },
                                updateStatus: updateStatus,
                                clientInfo: function () {
                                    return doRequest({
                                        url: '/api/applications/client-info'
                                    });
                                },
                                publish: {
                                    get: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: [
                                                '/api/app-gallery/application',
                                                options.applicationId,
                                                'brand',
                                                options.brand
                                            ].join('/')
                                        });
                                    },
                                    request: function (options) {
                                        options = options || {};
                                        var appProfileId = options.appProfileId;
                                        return doRequest({
                                            url: '/api/app-gallery/' + appProfileId + '/request-publish',
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    cancelRequest: function (options) {
                                        options = options || {};
                                        var appProfileId = options.appProfileId;
                                        return doRequest({
                                            url: '/api/app-gallery/' + appProfileId + '/cancel-request-publish',
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    takeDown: function (options) {
                                        options = options || {};
                                        var appProfileId = options.appProfileId;
                                        return doRequest({
                                            url: '/api/app-gallery/' + appProfileId + '/take-down',
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    save: function (options) {
                                        options = options || {};
                                        return doRequest({
                                            url: '/api/app-gallery',
                                            method: 'post',
                                            data: options
                                        });
                                    },
                                    publish: function (options) {
                                        options = options || {};
                                        var appProfileId = options.appProfileId;
                                        return doRequest({
                                            url: '/api/app-gallery/' + appProfileId + '/publish',
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    cancelPublish: function (options) {
                                        options = options || {};
                                        var appProfileId = options.appProfileId;
                                        return doRequest({
                                            url: '/api/app-gallery/' + appProfileId + '/cancel-publish',
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    getPreviewUrl: function (options) {
                                        options = options || {};
                                        var appProfileId = options.appProfileId;
                                        return doRequest({
                                            url: '/api/app-gallery/' + appProfileId + '/preview-url'
                                        })
                                    }
                                },
                                template: {
                                    get: function (appId) {
                                        return doRequest({
                                            url: '/api/app-profile-template/application/' + appId,
                                            method: 'get'
                                        });
                                    },
                                    update: function (profile) {
                                        return doRequest({
                                            url: '/api/app-profile-template',
                                            method: 'post',
                                            data: profile
                                        });
                                    },
                                    publish: function (appId, brandId, releaseTime) {
                                        return doRequest({
                                            url: '/api/app-profile-template/application/' + appId + '/brand/' + brandId,
                                            method: 'put',
                                            data: {
                                                releaseTime: releaseTime
                                            }
                                        });
                                    },
                                    unpublish: function (appId, brandId) {
                                        return doRequest({
                                            url: '/api/app-profile-template/application/' + appId + '/brand/' + brandId,
                                            method: 'delete'
                                        });
                                    },
                                    getPreviewUrl: function (appId) {
                                        return doRequest({
                                            url: 'api/app-profile-template/application/' + appId + '/preview-url',
                                            method: 'get'
                                        });
                                    }
                                },
                                usagePlan: {
                                    get: function (appId) {
                                        return doRequest({
                                            url: '/api/application/' + appId + '/usage-plan',
                                            method: 'get'
                                        });
                                    }
                                },
                                hasGraduatedProfiles: function (appId) {
                                    return doRequest({
                                        url: '/api/app-gallery/application/' + appId + '/has-graduated-profiles'
                                    });
                                },
                                isHipaa: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/application/' + options.applicationId + '/is-hipaa',
                                        noLoading: options.noLoading
                                    });
                                }
                            },
                            webhookInfo: {
                                get: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/webhook-info/' + options.applicationId,
                                        noLoading: options.noLoading
                                    });
                                }
                            },
                            keys: {
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys',
                                        method: 'get',
                                        params: {
                                            applicationId: options.applicationId
                                        },
                                        paging: paging
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys/' + options.id
                                    });
                                },
                                getProdCredentials: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys/' + options.id + '/credentials',
                                        noLoading: options.noLoading
                                    });
                                },
                                suspend: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-keys/' + options.id + '/suspend',
                                        data: {comment: options.comment},
                                        asForm: true
                                    });
                                },
                                activate: function (options) {
                                    return doRequest({
                                        url: '/api/app-keys/' + options.id + '/activate',
                                        data: {comment: options.comment},
                                        asForm: true
                                    });
                                }
                            },
                            developers: {
                                list: function (paging) {
                                    return doRequest({
                                        url: '/api/developers',
                                        paging: paging
                                    });
                                },
                                get: function (options) {
                                    options = options || {};
                                    var id = options.id || '~';
                                    return doRequest({
                                        url: '/api/developers/' + id
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    var id = options.id || '~';
                                    return doRequest({
                                        url: '/api/developers/' + id,
                                        method: 'put',
                                        data: options
                                    });
                                },
                                isPrimaryContact: function (id) {
                                    return doRequest({
                                        url: '/api/is-technical-contact/' + id
                                    });
                                },
                                changePassword: function (options) {
                                    options = options || {};
                                    var id = options.id || '~';
                                    return doRequest({
                                        url: ['/api/developers', id, 'change-password'].join('/'),
                                        method: 'put',
                                        data: options
                                    });
                                },
                                changeEmail: {
                                    sendCode: function (options) {
                                        options = options || {};
                                        var id = options.id || '~';
                                        return doRequest({
                                            url: ['/api/developers', id, 'send-verification-code'].join('/'),
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    resendCode: function (options) {
                                        options = options || {};
                                        var id = options.id || '~';
                                        return doRequest({
                                            url: ['/api/developers', id, 'resend-verification-code'].join('/'),
                                            method: 'put',
                                            data: options
                                        });
                                    },
                                    updateEmail: function (options) {
                                        options = options || {};
                                        var id = options.id || '~';
                                        return doRequest({
                                            url: ['/api/developers', id, 'update-email'].join('/'),
                                            method: 'put',
                                            data: options
                                        });
                                    }
                                },
                                rolePermission: rolePermission,
                            },
                            organizations: {
                                get: function () {
                                    return doRequest({
                                        url: '/api/organizations/~'
                                    });
                                },
                                getPartnerType: function () {
                                    return doRequest({
                                        url: '/api/organizations/~/partner-badge',
                                        noLoading: true
                                    });
                                },
                                update: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/organizations/~',
                                        data: options,
                                        asForm: true,
                                        method: 'put'
                                    });
                                },
                                getOrgLevelData: function () {
                                    return doRequest({
                                        url: '/api/orgLevelData/~'
                                    });
                                },
                            },
                            freeTier: {
                                signUpCheck: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/sign-up/check',
                                        method: 'post',
                                        data: options
                                    });
                                },
                                checkUniqueness: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/uniqueness/check',
                                        method: 'post',
                                        data: options
                                    });
                                },
                                signUp: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/register',
                                        method: 'post',
                                        data: options
                                    });
                                },
                                checkEmail: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/email/check',
                                        method: 'post',
                                        data: options
                                    });
                                },
                                mobileSignUp: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/mobile/register',
                                        method: 'post',
                                        data: options
                                    });
                                }
                            },
                            freeExtension: {
                                maxCount: function () {
                                    return doRequest({
                                        url: '/api/free-extension/max-count'
                                    });
                                },
                                invitePreCheck: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/free-extension/invite-pre-check',
                                        method: 'post',
                                        data: options
                                    })
                                },
                                sendInvitation: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/free-extension/invite',
                                        method: 'post',
                                        data: options
                                    })
                                },
                                checkSignUpPrerequisite: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/free-extension/sign-up-verify',
                                        method: 'post',
                                        data: options
                                    })
                                },
                                signUp: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/free-extension/sign-up',
                                        method: 'post',
                                        data: options
                                    })
                                },
                                delete: function (developerId) {
                                    return doRequest({
                                        url: '/api/free-extension/' + developerId,
                                        method: 'delete'
                                    })
                                }
                            },
                            grantTypes: function () {
                                return doRequest({
                                    url: '/api/grant-types'
                                });
                            },
                            permissions: function () {
                                return doRequest({
                                    url: '/api/permissions'
                                });
                            },

                            developerProvision: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/developer-provision',
                                    data: options.data
                                });
                            },

                            /**
                             * @param {Object} options
                             * @param {String} options.applicationId - Application Id
                             * @param {Boolean} options.retrieve - Force to retrieve
                             * @returns {promise}
                             */
                            appStatsDashboard: function (options) {
                                options = options || {};

                                return doRequest({
                                    url: '/api/applications/' + options.applicationId + '/journey-dashboard',
                                    params: options,
                                    noLoading: options.noLoading
                                });
                            },

                            /**
                             * @param options
                             * @param {String} options.applicationId
                             * @param {String} options.permission
                             * @returns {promise}
                             */
                            appStatsDeletePermission: function (options) {
                                options = options || {};

                                return doRequest({
                                    url: '/api/applications/' + options.applicationId + '/delete-permission',
                                    method: 'put',
                                    data: options
                                });
                            },

                            supportCases: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/support-cases',
                                    data: options
                                });
                            },
                            appGallery: {
                                list: function (options, paging) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/app-gallery',
                                        params: options,
                                        paging: paging
                                    });
                                },
                                listOriginsAndRevisionsWithAppId: listProfileOriginsAndRevisionsWithAppId,
                                get: function (id) {
                                    return doRequest({
                                        url: '/api/app-gallery/' + id
                                    });
                                },
                            },

                            eventBanner: {
                                get: function () {
                                    return doRequest({
                                        url: '/api/event-banner',
                                        noLoading: true
                                    });
                                }
                            }
                        },

                        /**
                         * @deprecated
                         */
                        blog: {
                            get: function (options) {
                                options = options || {};
                                var id = options.id || '';
                                return doRequest({
                                    url: '/api/posts/' + id
                                });
                            }
                        },
                        community: {
                            getBlogPosts: function () {
                                return doRequest({
                                    url: '/api/medium/posts',
                                    noLoading: true
                                });
                            },
                            getAnswerHubPosts: function () {
                                return doRequest({
                                    url: '/api/community-ah/posts',
                                    noLoading: true
                                });
                            }
                        },
                        support: {
                            servicesConsult: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/service-consult-email',
                                    method: 'post',
                                    data: options.data
                                });
                            },
                            developerEvents: {
                                getFeaturedEvents: function () {
                                    return doRequest({url: '/api/events/featured'});
                                },
                                getAllEvents: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/events',
                                        params: {
                                            eventStartDateFrom: moment().subtract(1, 'years').toISOString(),
                                            eventStartDateTo: moment().add(5, 'years').toISOString()
                                        },
                                        noLoading: options.noLoading
                                    })
                                }
                            }
                        },
                        reports: {
                            /**
                             * Fetch Application's request data, includes Request/Error count.
                             *
                             * @param options.statTime      - Query start time
                             * @param options.endTime       - Query end time
                             * @param options.applicationId - Application ID
                             * @param options.metrics       - Request metrics
                             * @param options.noLoading     - Whether to show loading state or not
                             * @returns {promise}
                             */
                            request: function (options) {
                                return doRequest({
                                    url: '/api/report/request',
                                    method: 'get',
                                    params: options,
                                    noLoading: options.noLoading
                                });
                            },
                            statusCode: function (options) {
                                return doRequest({
                                    url: '/api/report/status-code',
                                    method: 'get',
                                    params: options,
                                    noLoading: options.noLoading
                                });
                            },
                            permission: function (options) {
                                return doRequest({
                                    url: '/api/report/permissions',
                                    method: 'get',
                                    params: options,
                                    noLoading: options.noLoading
                                });
                            },
                            responseTime: function (options) {
                                return doRequest({
                                    url: '/api/report/response-time',
                                    method: 'get',
                                    params: options,
                                    noLoading: options.noLoading
                                });
                            },
                        },
                        acceptTerms: function () {
                            return doRequest({
                                url: '/api/accept-terms',
                                method: 'post'
                            });
                        },
                        appStates: appStates,
                        appGallery: {
                            initImageDir: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-gallery/init-image-dir',
                                    data: options,
                                    asForm: true
                                });
                            },
                            duplicateImages: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-gallery/duplicate-images',
                                    method: 'post',
                                    data: options
                                });
                            },
                            list: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-gallery-view',
                                    noLoading: _.get(options, 'noLoading', true),
                                    params: options
                                });
                            },
                            get: function (appId) {
                                return doRequest({
                                    url: '/api/app-gallery-view/' + appId
                                });
                            },
                            getAppCategories: function (brandId) {
                                return doRequest({
                                    url: '/api/app-gallery-view/category-options/brand/' + brandId
                                });
                            },
                            statusHistory: function (options, paging) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-gallery/' + options.appProfileId + '/status-history',
                                    params: options.params,
                                    paging: paging
                                });
                            }
                        },
                        appProfileRevision: {
                            get: function (appProfileId) {
                                return doRequest({
                                    url: '/api/app-profile-revision/' + appProfileId
                                });
                            },
                            mergeRequest: function (appProfileId, summary) {
                                return doRequest({
                                    url: '/api/app-profile-revision/' + appProfileId + '/merge-request',
                                    data: {
                                        comment: summary
                                    },
                                    method: 'put'
                                });
                            },
                            cancelRequest: function (appProfileId) {
                                return doRequest({
                                    url: '/api/app-profile-revision/' + appProfileId + '/merge-cancel',
                                    method: 'put'
                                });
                            },
                            previewUrl: function (appProfileId) {
                                return doRequest({
                                    url: '/api/app-gallery/' + appProfileId + '/revision-preview-url'
                                });
                            }
                        },
                        parameters: {
                            defaults: {
                                list: function () {
                                    return doRequest({
                                        url: '/api/parameters/default'
                                    });
                                },
                                edit: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/default/' + options.id,
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                delete: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/default/' + options.id,
                                        method: 'delete'
                                    });
                                }
                            },
                            organization: {
                                list: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/organization/' + options.id,
                                        method: 'get'
                                    });
                                },
                                edit: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/organization/' + options.orgId + '/parameter/' + options.paramId,
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                delete: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/organization/' + options.orgId + '/parameter/' + options.paramId,
                                        method: 'delete'
                                    });
                                }
                            },
                            application: {
                                list: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/application/' + options.id,
                                        method: 'get'
                                    });
                                },
                                edit: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/application/' + options.appId + '/parameter/' + options.paramId,
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                delete: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/parameters/application/' + options.appId + '/parameter/' + options.paramId,
                                        method: 'delete'
                                    });
                                }
                            }
                        },
                        botProvision: {
                            get: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-keys/' + options.appKeyId + '/bot',
                                    method: 'get'
                                });
                            },
                            install: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-keys/' + options.appKeyId + '/bot',
                                    data: options,
                                    method: 'post'
                                });
                            },
                            remove: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-keys/' + options.appKeyId + '/bot',
                                    method: 'delete',
                                });
                            },
                            getConfirmation: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-keys/' + options.appId + '/conformation'
                                });
                            },
                            getAccessToken: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-keys/' + options.appKeyId + '/access-token'
                                });
                            },
                            regenerateAccessToken: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/app-keys/' + options.appKeyId + '/bot/generate-token',
                                    method: 'post',
                                });
                            },
                            botName: {
                                get: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.appId + '/bot-info',
                                        method: 'get'
                                    });
                                },
                                save: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.appId + '/bot-name',
                                        data: options.data,
                                        method: 'put'
                                    });
                                },
                                allowConfigure: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.appId + '/bot-name/allow-configuring',
                                        method: 'put'
                                    });
                                },
                                disallowConfigure: function (options) {
                                    options = options || {};
                                    return doRequest({
                                        url: '/api/applications/' + options.appId + '/bot-name/disallow-configuring',
                                        method: 'put'
                                    });
                                }
                            }
                        },
                        freeAccountUpgrade: {
                            sendRequest: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/free-account-upgrade/send-request',
                                    method: 'post',
                                    data: options
                                });
                            }
                        },
                        country: {
                            list: function (options) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/countries',
                                    method: 'get',
                                    params: options
                                });
                            }
                        },
                        securityQuestion: {
                            list: function () {
                                return doRequest({
                                    url: '/api/secret-question'
                                });
                            }
                        },
                        contentful: {
                            siteWide: function () {
                                return doRequest({
                                    url: '/api/content/site-wide',
                                    noLoading: true
                                });
                            },
                            homePage: function () {
                                return doRequest({
                                    url: '/api/content/home-page',
                                    noLoading: true
                                });
                            },
                            menuADs: function () {
                                return doRequest({
                                    url: '/api/menu-ads',
                                    noLoading: true
                                })
                            },
                            menu: function () {
                                return doRequest({
                                    url: '/api/content/menu/menu-detail'
                                });
                            }
                        },
                        timezone: {
                            get: function () {
                                return doRequest({
                                    url: '/api/timezones'
                                });
                            }
                        },
                        leadsReport: {
                            search: function (options, paging) {
                                options = options || {};
                                return doRequest({
                                    url: '/api/leads',
                                    params: options,
                                    paging: paging
                                });
                            },
                            isVisible: function () {
                                return doRequest({
                                    url: '/api/show-leads-report',
                                    noLoading: true
                                });
                            }
                        },
                        devTrialUser: {
                            isSignUpEnabled: function () {
                                return doRequest({
                                    url: '/api/enable-dev-account-signup'
                                })
                            },
                            expirationInfo: function () {
                                return doRequest({
                                    url: '/api/dev-trial-user/expiration-info'
                                });
                            },
                            cancel: function () {
                                return doRequest({
                                    url: '/api/dev-trial-user/cancel',
                                    method: 'post'
                                });
                            }
                        }
                    };

                    function getBlogPosts(params) {
                        params = params || {};
                        params.perPage = params.perPage || 5;
                        params.page = params.page || 1;

                        return doRequest({
                            url: '/api/posts',
                            params: params
                        });
                    }

                    /**
                     * Request with options, fallback when failed.
                     * Status code 200 ~ 299 is considered as SUCCESS.
                     * Return Promise which would be fulfilled with transformed data or rejected.
                     *
                     * @param options
                     * @param fallbackOptions
                     * @returns {*}
                     */
                    function doRequestWithFallback(options, fallbackOptions) {
                        return doRequest(options)
                            .then(parseResponse)
                            .then(function (data) {
                                return data;
                            }, function () {
                                return doRequest(fallbackOptions)
                                    .then(parseResponse);
                            });

                        function parseResponse(res) {
                            return $q(function (resolve, reject) {
                                var isSuccess = /2\d\d/.test(res.status);
                                isSuccess ? resolve(res.data) : reject();
                            });
                        }
                    }


                    /**
                     * Wrapper for $http.
                     *
                     * @param {object} o
                     * @param {string} o.url Resource URL.
                     * @param {string} [o.method=get] Request method
                     * @param {string|object} [o.params] Query string after the URL.
                     * @param {string|object} [o.data] Data sent as request body via post.
                     * @param {string} [o.headers] additional headers.
                     * @param {number} [o.timeout] Timeout in milliseconds.
                     * @returns {promise}
                     * @todo Need the unit test coverage - Vi
                     */
                    function doRequest(o) {
                        var options = angular.copy(o);

                        options.method = options.method || (angular.isDefined(options.data) ? 'post' : 'get');
                        options.params = options.params || {};

                        handleSortObj(options.params);
                        addPagingParam(options);
                        addAntiCacheParam(options);
                        clearParams(options);
                        adaptFormRequest(options);

                        return $http(options);
                    }

                    function addPagingParam(options) {
                        if (options.paging) {
                            options.params = angular.extend(options.params, options.paging);
                        }
                    }

                    function addAntiCacheParam(options) {
                        if (options.method === 'get' && (options.antiCache !== false)) {
                            options.params.r = Math.random();
                        }
                    }

                    function adaptFormRequest(options) {
                        if (options.asForm) {
                            options.headers = _.assign(options.headers || {}, {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                            });
                            options.data = $.param(options.data);
                        }
                    }

                    function handleSortObj(options) {
                        if (!options.hasOwnProperty('sortObj')) {
                            return;
                        }
                        var sortOrder = [];
                        var sortBy = [];
                        angular.forEach(options.sortObj, function (item, keyName) {
                            if (item == null) {
                                return;
                            }
                            sortBy.push(keyName);
                            sortOrder.push(item ? 'asc' : 'desc');
                        });
                        delete options.sortObj;
                        options.sortOrder = sortOrder.join(',');
                        options.sortBy = sortBy.join(',');
                    }

                    function clearParams(options) {
                        var params = options.params;
                        var emptyKeys = [];
                        if (params) {
                            for (var key in params) {
                                if (params.hasOwnProperty(key) && (params[key] == null || params[key] === '')) {
                                    emptyKeys.push(key);
                                }
                            }
                            angular.forEach(emptyKeys, function (keyName) {
                                delete params[keyName];
                            });
                        }
                    }
                }];
        }
    );
